// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__burG9","title":"BackImages_title__2x9bv","images":"BackImages_images__2YRcY"};